import React from "react";

export default function MSAccess_IsDate() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_IsDate</h1>
      <p>This is the MSAccess_IsDate component generated from the SQL JSON.</p>
    </div>
  );
}
